// import jwtHelper from './jwt-helper';
// import authorDomain from './domain-manager';
import { storageKeys } from './browser-storage/storage-keys';

const session = {
    accessTokenValid(): boolean {
        try {
            const token = this.getAccessToken();

            return !(typeof token !== 'string' || token === 'undefined');
        } catch (e) {
            return false;
        }
    },

    clearAccessToken(): void {
        window.storage.removeItem(storageKeys.auth.accessToken);
    },

    clearError(): void {
        window.storage.removeItem(storageKeys.general.lastError);
    },

    getAccessToken(): string {
        return window.storage.getItem(storageKeys.auth.accessToken);
    },

    hasPreviousError(): boolean {
        return window.storage.getItem(storageKeys.general.lastError) !== '';
    },

    impersonated(): boolean {
        return Number(window.storage.getItem(storageKeys.user.impersonated)) === 1;
    },

    isLoggedIn(): boolean {
        return (
            window.storage.getItem(storageKeys.auth.isLoggedIn) === '1' ||
            window.storage.getItem(storageKeys.auth.isLoggedIn) === 'true'
        );
    },

    setAccessToken(token: string): string {
        return window.storage.setItem(storageKeys.auth.accessToken, token);
    },

    setError(error: string): void {
        window.storage.setItem(storageKeys.general.lastError, error);
    },

    setLoggedIn(loggedIn: number): void {
        window.storage.setItem(storageKeys.auth.isLoggedIn, loggedIn);
    }
};

export default session;
